import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SystemNotificationAPIService } from '../../../services/API/SystemNotificationAPI.service';
@Injectable({
    providedIn: 'root'
  })


export class SystemNotificationCatalogService{
  public systemNotification: string = "";

  constructor(
    private systemNotificationService: SystemNotificationAPIService,){
  }

  GetActive(){
    return this.systemNotificationService.GetActive();
  }
}
